import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addCompanyTodo = createAsyncThunk('addCompany', async (data) => {


    var bodyFormData = new FormData()

    bodyFormData.append('company_name', data?.values?.name)
    bodyFormData.append('company_logo', data?.values?.logo)
    // bodyFormData.append('status', data?.values?.status)

    try {
        const res = await axios({

            method: 'POST',
            url: getConfig.API_URL + 'company',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "Authorization": SessionManager.getCookie("user_token"), type: "company" }

        })
        return res
    } catch (error) {
        return error.response
    }
})
